import { ComponentBase, ComponentOptionsBase } from './ComponentBase';

export interface PageOptionsBase extends ComponentOptionsBase {
}

export abstract class PageBase<T extends PageOptionsBase> extends ComponentBase<T> {
    abstract init(): void;

    protected _filterDelim: string = "-delim-";
}


/** WEBPACK FOOTER **
 ** ./Typescript/Common/PageBase.ts
 **/